/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateVehicleRequest
 */
export interface CreateVehicleRequest {
    /**
     * 無線番号
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    radioNo: string;
    /**
     * グループコード
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    companyCode: string;
    /**
     * 営業所ID
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    salesOfficeId: string;
    /**
     * ナンバープレート上部
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    plateNoUpper: string;
    /**
     * ナンバープレート下部
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    plateNoBottom: string;
    /**
     * ドア番号
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    doorNo?: string;
    /**
     * 車種コード
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    carTypeCode: string;
    /**
     * 車体色のRGBコード
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    colorRgb: string;
    /**
     * 初度登録年月（YYYY/MM）
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    firstRegistrationDate: string;
    /**
     * メーターモード (0:迎車連携有り, 1:迎車連携無し, 2:メータ無し)
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    meterMode: CreateVehicleRequestMeterModeEnum;
    /**
     * 事業者連絡機能可否
     * @type {boolean}
     * @memberof CreateVehicleRequest
     */
    companyMsgAvailable: boolean;
    /**
     * 配車可能フラグ
     * @type {boolean}
     * @memberof CreateVehicleRequest
     */
    available: boolean;
    /**
     * 個人タクシー事業者名（個人タクシーのみ）
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    ownerDrivenTaxiName?: string;
    /**
     * インボイス番号（個人タクシーのみ）
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    invoiceNo?: string;
    /**
     * 備考（任意）
     * @type {string}
     * @memberof CreateVehicleRequest
     */
    description?: string;
}


/**
 * @export
 */
export const CreateVehicleRequestMeterModeEnum = {
    _0: '0',
    _1: '1',
    _2: '2'
} as const;
export type CreateVehicleRequestMeterModeEnum = typeof CreateVehicleRequestMeterModeEnum[keyof typeof CreateVehicleRequestMeterModeEnum];


/**
 * Check if a given object implements the CreateVehicleRequest interface.
 */
export function instanceOfCreateVehicleRequest(value: object): value is CreateVehicleRequest {
    if (!('radioNo' in value) || value['radioNo'] === undefined) return false;
    if (!('companyCode' in value) || value['companyCode'] === undefined) return false;
    if (!('salesOfficeId' in value) || value['salesOfficeId'] === undefined) return false;
    if (!('plateNoUpper' in value) || value['plateNoUpper'] === undefined) return false;
    if (!('plateNoBottom' in value) || value['plateNoBottom'] === undefined) return false;
    if (!('carTypeCode' in value) || value['carTypeCode'] === undefined) return false;
    if (!('colorRgb' in value) || value['colorRgb'] === undefined) return false;
    if (!('firstRegistrationDate' in value) || value['firstRegistrationDate'] === undefined) return false;
    if (!('meterMode' in value) || value['meterMode'] === undefined) return false;
    if (!('companyMsgAvailable' in value) || value['companyMsgAvailable'] === undefined) return false;
    if (!('available' in value) || value['available'] === undefined) return false;
    return true;
}

export function CreateVehicleRequestFromJSON(json: any): CreateVehicleRequest {
    return CreateVehicleRequestFromJSONTyped(json, false);
}

export function CreateVehicleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateVehicleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'radioNo': json['radio_no'],
        'companyCode': json['company_code'],
        'salesOfficeId': json['sales_office_id'],
        'plateNoUpper': json['plate_no_upper'],
        'plateNoBottom': json['plate_no_bottom'],
        'doorNo': json['door_no'] == null ? undefined : json['door_no'],
        'carTypeCode': json['car_type_code'],
        'colorRgb': json['color_rgb'],
        'firstRegistrationDate': json['first_registration_date'],
        'meterMode': json['meter_mode'],
        'companyMsgAvailable': json['company_msg_available'],
        'available': json['available'],
        'ownerDrivenTaxiName': json['owner_driven_taxi_name'] == null ? undefined : json['owner_driven_taxi_name'],
        'invoiceNo': json['invoice_no'] == null ? undefined : json['invoice_no'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateVehicleRequestToJSON(json: any): CreateVehicleRequest {
    return CreateVehicleRequestToJSONTyped(json, false);
}

export function CreateVehicleRequestToJSONTyped(value?: CreateVehicleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'radio_no': value['radioNo'],
        'company_code': value['companyCode'],
        'sales_office_id': value['salesOfficeId'],
        'plate_no_upper': value['plateNoUpper'],
        'plate_no_bottom': value['plateNoBottom'],
        'door_no': value['doorNo'],
        'car_type_code': value['carTypeCode'],
        'color_rgb': value['colorRgb'],
        'first_registration_date': value['firstRegistrationDate'],
        'meter_mode': value['meterMode'],
        'company_msg_available': value['companyMsgAvailable'],
        'available': value['available'],
        'owner_driven_taxi_name': value['ownerDrivenTaxiName'],
        'invoice_no': value['invoiceNo'],
        'description': value['description'],
    };
}

